import './init-global-components'
import App from './src/app'
import ReactRailsUJS from 'react_ujs'

const ns = typeof window === 'undefined' ? global : window

ns.App = App
ns.ReactRailsUJS = ReactRailsUJS
